/**
 * Function to format cents to USD
 * @param {number} cents - The amount in cents to be formatted
 * @returns {string} - The formatted amount in USD
 */
export function formatCentsToUsd(cents) {
    if (cents === null || cents === undefined) {
        return null;
    }
    const n = Number(cents);
    if (!Number.isFinite(n)) {
        return '?';
    }
    // Round half away from zero to match MySQL ROUND() (the migration backfill)
    // and the XLSX export, so negative refund/cancelled values agree between the
    // on-screen table and the sheet instead of drifting by a cent.
    const c = Math.sign(n) * Math.round(Math.abs(n));

    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    }).format(c / 100);
}
